import React from 'react';
import { useForm } from 'react-hook-form';
import { useSendPushNotificationMutation } from '@/queries/push/useSendPushNotificationMutation';
import { Button, FormRow } from '../../controls';
import { EventRelatedSection } from '../EventRelatedSection';

const MESSAGE_MAX_LENGTH = 200;

export function PushNotificationsSection({ festivalId }) {
  const sendMutation = useSendPushNotificationMutation(festivalId);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { text: '' },
    mode: 'onSubmit',
  });

  const messageText = watch('text') ?? '';
  const characterCount = messageText.length;

  const onSubmit = (values) => {
    sendMutation.mutate(values, {
      onSuccess: () => {
        reset({ text: '' });
      },
    });
  };

  return (
    <EventRelatedSection
      icon={['fas', 'bell']}
      title="Push Notifications"
      contentOnly
    >
      <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
        <FormRow label="Message" error={errors.text?.message}>
          <textarea
            placeholder="Enter a short message to send to attendees (200 characters maximum)."
            maxLength={MESSAGE_MAX_LENGTH}
            {...register('text', {
              required: 'Message is required',
              maxLength: {
                value: MESSAGE_MAX_LENGTH,
                message: `Message must be ${MESSAGE_MAX_LENGTH} characters or fewer`,
              },
            })}
          />
          <p className="m-0 mt-1 text-sm text-[var(--muted-foreground)]">
            ({characterCount} / {MESSAGE_MAX_LENGTH} characters)
          </p>
        </FormRow>
        <div className="flex justify-end">
          <Button type="submit" disabled={sendMutation.isPending} mode="dark">
            Send Notification
          </Button>
        </div>
      </form>
    </EventRelatedSection>
  );
}
